import React from "react";
import css from "./css.css";
// import ScrollLock from 'react-scrolllock';
import getConfig from "../../config";
import { connect } from '~/redux/connect'
import { HStack, Text, VStack, } from "~/native-ui";

export const AboutUs = connect()((props) => {
    const adminVersion =  getConfig().version;
    const versions = [
        { label: props.trans("versions.admin"), version:  adminVersion }
    ].map((item) => (
        <HStack key={item.label}><Text>{item.label}: <Text bold>v{item.version}</Text></Text></HStack>
    ));
    return (
        // <ScrollLock>
            <VStack space={2}>
                { versions }
            </VStack>
        // </ScrollLock>
    )
})

AboutUs.dialogClassName = css.version_dialog